<div class="d-flex h-100">
  <div
    class="remove-cc-dialog m-auto write-review-dialog d-flex flex-column"
    style="position: relative;"
    (click)="$event.stopPropagation()">
    <udex-control-button
      style="position: absolute; right: 3rem"
      [tabindex]="0"
      dcpAutofocus
      (click)="this.launchDialogService.closeDialog('Dialog close')"
      (keyup.enter)="this.launchDialogService.closeDialog('Dialog close')"
      icon="decline"
      size="Small"
      accessible-role="Button">
    </udex-control-button>
    <span class="mb-4 heading__bold--xs" data-cy="header">
      {{ 'checkout.digitalNativeCheckout.paymentType.cc.remove.header' | cxTranslate }}
    </span>
    <div data-cy="message">
      {{ 'checkout.digitalNativeCheckout.paymentType.cc.remove.message' | cxTranslate: {cardBrand, last4Digits} }}
    </div>
    <div class="d-flex udex-mt-20" style="gap: 1rem;">
      <udex-button [disabled]="inProgress" (click)="removeCreditCard(creditCardData)" size="Large" design="Primary"
                   data-cy="remove-btn">
        @if (inProgress) {
          <ui5-busy-indicator size="M" delay="0.2" class="white-dots d-flex" active></ui5-busy-indicator>
        } @else {
          {{ 'checkout.digitalNativeCheckout.paymentType.cc.remove.removeButton' | cxTranslate }}
        }
      </udex-button>
      <udex-button [disabled]="inProgress" (click)="this.launchDialogService.closeDialog('Dialog close')" size="Large" design="Secondary"
         data-cy="cancel-btn"
      >
        {{ 'common.cancel' | cxTranslate }}
      </udex-button>
    </div>
  </div>
</div>
